import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export const attendanceStatusListApi = async (payload) => {
  return await api.get(
    `${apiPath.API_URL}${apiPath.status.status_list}`,
    {
      params: payload,
    }
  );
};

export const createStatusApi = async (payload) => {
  return await api.post(
    `${apiPath.API_URL}${apiPath.status.status_create}`,
    {
      AttendanceStatus: payload.AttendanceStatus,
      ShortName: payload.ShortName,
      Status:payload.Status ? 1 : 0,
    }
  );
};

export const getAttendanceStatusApi = async (payload) => {
  return await api.get(
    `${apiPath.API_URL}${apiPath.status.getStatusById}/${payload.AttendanceStatusCode}`
    
  )
}

export const updateStatusApi = async(payload) => {
  return await api.put(
    `${apiPath.API_URL}${apiPath.status.status_update}/${payload.AttendanceStatusCode}`,
    {
      AttendanceStatus:payload.AttendanceStatus,
      ShortName: payload.ShortName,
            Status:payload.Status ? 1 : 0,

    }
  );
};

export const deleteStatusApi = async(payload) => {
  return await api.delete(
    `${apiPath.API_URL}${apiPath.status.status_delete}/${payload.AttendanceStatusCode}`,
  )
}